import React from 'react';

import RoundedButtonWithArrow from '@shared/components/inputs/buttons/RoundedButtonWithArrow';
import Loading from '@shared/components/loading/Loading';

import { Input } from '@paretogroup/tess';
import { ColorConstants } from '@shared/constants';
import { useFormFields } from '../integrations.hooks';
import { WoocommerceIntegrationData } from './woocommerce.state';
import * as S from '../integration-strategies/modal-strategy/modal-strategy.styles';
import { FIELDS } from './woocommerce.constants';
import { ButtonStyle } from '../vtex-integration/vtex-modal.styles';

type Props = {
    initialData: WoocommerceIntegrationData,
    onSubmit: (payload: WoocommerceIntegrationData) => void
    isSubmitting: boolean
    isLoading: boolean
}

export const WoocommerceModal = ({
    initialData,
    onSubmit,
    isSubmitting = false,
    isLoading = true,
}: Props) => {
    const {
        fields,
        handleFieldChange,
        handleSubmit,
    } = useFormFields({ initialData, onSubmit });

    const classes = S.useStyles();

    return isLoading
        ? <Loading height="20px" /> : (
            <form onSubmit={handleSubmit}>
                {
                    Object.values(FIELDS).map(({
                        LABEL, NAME, PLACEHOLDER, TEST_ID,
                    }) => (
                        <Input
                            fullWidth
                            label={LABEL}
                            data-testid={TEST_ID}
                            onChange={handleFieldChange(NAME)}
                            placeholder={PLACEHOLDER}
                            value={fields[NAME]}
                            key={NAME}
                            classes={classes}
                        />
                    ))
                }

                <RoundedButtonWithArrow
                    isDisabled={isSubmitting}
                    isLoading={isSubmitting}
                    label="Integrate now"
                    styles={ButtonStyle}
                    background={null}
                    color={ColorConstants.white}
                    onClick={null}
                />
            </form>
        );
};
